import _toConsumableArray from "/codebuild/output/src3057483688/src/services/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/codebuild/output/src3057483688/src/services/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/codebuild/output/src3057483688/src/services/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { isMatchingPattern, addInstrumentationHandler, isInstanceOf, BAGGAGE_HEADER_NAME, mergeAndSerializeBaggage } from '@sentry/utils';
import { hasTracingEnabled, getActiveTransaction } from '../utils.js';
var DEFAULT_TRACING_ORIGINS = ['localhost', /^\//];
/** Options for Request Instrumentation */

var defaultRequestInstrumentationOptions = {
  traceFetch: true,
  traceXHR: true,
  tracingOrigins: DEFAULT_TRACING_ORIGINS
};
/** Registers span creators for xhr and fetch requests  */

function instrumentOutgoingRequests(_options) {
  var _defaultRequestInstru = _objectSpread(_objectSpread({}, defaultRequestInstrumentationOptions), _options),
      traceFetch = _defaultRequestInstru.traceFetch,
      traceXHR = _defaultRequestInstru.traceXHR,
      tracingOrigins = _defaultRequestInstru.tracingOrigins,
      shouldCreateSpanForRequest = _defaultRequestInstru.shouldCreateSpanForRequest; // We should cache url -> decision so that we don't have to compute
  // regexp everytime we create a request.


  var urlMap = {};

  var defaultShouldCreateSpan = function defaultShouldCreateSpan(url) {
    if (urlMap[url]) {
      return urlMap[url];
    }

    var origins = tracingOrigins;
    urlMap[url] = origins.some(function (origin) {
      return isMatchingPattern(url, origin);
    }) && !isMatchingPattern(url, 'sentry_key');
    return urlMap[url];
  }; // We want that our users don't have to re-implement shouldCreateSpanForRequest themselves
  // That's why we filter out already unwanted Spans from tracingOrigins


  var shouldCreateSpan = defaultShouldCreateSpan;

  if (typeof shouldCreateSpanForRequest === 'function') {
    shouldCreateSpan = function shouldCreateSpan(url) {
      return defaultShouldCreateSpan(url) && shouldCreateSpanForRequest(url);
    };
  }

  var spans = {};

  if (traceFetch) {
    addInstrumentationHandler('fetch', function (handlerData) {
      fetchCallback(handlerData, shouldCreateSpan, spans);
    });
  }

  if (traceXHR) {
    addInstrumentationHandler('xhr', function (handlerData) {
      xhrCallback(handlerData, shouldCreateSpan, spans);
    });
  }
}
/**
 * Create and track fetch request spans
 */


function fetchCallback(handlerData, shouldCreateSpan, spans) {
  if (!hasTracingEnabled() || !(handlerData.fetchData && shouldCreateSpan(handlerData.fetchData.url))) {
    return;
  }

  if (handlerData.endTimestamp) {
    var spanId = handlerData.fetchData.__span;
    if (!spanId) return;
    var span = spans[spanId];

    if (span) {
      if (handlerData.response) {
        // TODO (kmclb) remove this once types PR goes through
        span.setHttpStatus(handlerData.response.status);
      } else if (handlerData.error) {
        span.setStatus('internal_error');
      }

      span.finish();
      delete spans[spanId];
    }

    return;
  }

  var activeTransaction = getActiveTransaction();

  if (activeTransaction) {
    var span = activeTransaction.startChild({
      data: _objectSpread(_objectSpread({}, handlerData.fetchData), {}, {
        type: 'fetch'
      }),
      description: "".concat(handlerData.fetchData.method, " ").concat(handlerData.fetchData.url),
      op: 'http.client'
    });
    handlerData.fetchData.__span = span.spanId;
    spans[span.spanId] = span;
    var request = handlerData.args[0] = handlerData.args[0];
    var options = handlerData.args[1] = handlerData.args[1] || {};
    options.headers = addTracingHeaders(request, span, options);
  }
}

function addTracingHeaders(request, span, options) {
  var headers = options.headers;

  if (isInstanceOf(request, Request)) {
    headers = request.headers;
  }

  var incomingBaggage = span.getBaggage();

  if (headers) {
    if (typeof headers.append === 'function') {
      headers.append('sentry-trace', span.toTraceparent());
      headers.append(BAGGAGE_HEADER_NAME, mergeAndSerializeBaggage(incomingBaggage, headers.get(BAGGAGE_HEADER_NAME)));
    } else if (Array.isArray(headers)) {
      var _headers$find = headers.find(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            _ = _ref2[1];

        return key === BAGGAGE_HEADER_NAME;
      }),
          _headers$find2 = _slicedToArray(_headers$find, 2),
          headerBaggageString = _headers$find2[1];

      headers = [].concat(_toConsumableArray(headers), [['sentry-trace', span.toTraceparent()], [BAGGAGE_HEADER_NAME, mergeAndSerializeBaggage(incomingBaggage, headerBaggageString)]]);
    } else {
      headers = _objectSpread(_objectSpread({}, headers), {}, {
        'sentry-trace': span.toTraceparent(),
        baggage: mergeAndSerializeBaggage(incomingBaggage, headers.baggage)
      });
    }
  } else {
    headers = {
      'sentry-trace': span.toTraceparent(),
      baggage: mergeAndSerializeBaggage(incomingBaggage)
    };
  }

  return headers;
}
/**
 * Create and track xhr request spans
 */


function xhrCallback(handlerData, shouldCreateSpan, spans) {
  if (!hasTracingEnabled() || handlerData.xhr && handlerData.xhr.__sentry_own_request__ || !(handlerData.xhr && handlerData.xhr.__sentry_xhr__ && shouldCreateSpan(handlerData.xhr.__sentry_xhr__.url))) {
    return;
  }

  var xhr = handlerData.xhr.__sentry_xhr__; // check first if the request has finished and is tracked by an existing span which should now end

  if (handlerData.endTimestamp) {
    var spanId = handlerData.xhr.__sentry_xhr_span_id__;
    if (!spanId) return;
    var span = spans[spanId];

    if (span) {
      span.setHttpStatus(xhr.status_code);
      span.finish();
      delete spans[spanId];
    }

    return;
  } // if not, create a new span to track it


  var activeTransaction = getActiveTransaction();

  if (activeTransaction) {
    var span = activeTransaction.startChild({
      data: _objectSpread(_objectSpread({}, xhr.data), {}, {
        type: 'xhr',
        method: xhr.method,
        url: xhr.url
      }),
      description: "".concat(xhr.method, " ").concat(xhr.url),
      op: 'http.client'
    });
    handlerData.xhr.__sentry_xhr_span_id__ = span.spanId;
    spans[handlerData.xhr.__sentry_xhr_span_id__] = span;

    if (handlerData.xhr.setRequestHeader) {
      try {
        handlerData.xhr.setRequestHeader('sentry-trace', span.toTraceparent());
        var headerBaggageString = handlerData.xhr.getRequestHeader && handlerData.xhr.getRequestHeader(BAGGAGE_HEADER_NAME);
        handlerData.xhr.setRequestHeader(BAGGAGE_HEADER_NAME, mergeAndSerializeBaggage(span.getBaggage(), headerBaggageString));
      } catch (_) {// Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
      }
    }
  }
}

export { DEFAULT_TRACING_ORIGINS, defaultRequestInstrumentationOptions, fetchCallback, instrumentOutgoingRequests, xhrCallback };